import { render, staticRenderFns } from "./ServiceBanquetStep2.vue?vue&type=template&id=3ec693c4&scoped=true"
import script from "./ServiceBanquetStep2.vue?vue&type=script&lang=js"
export * from "./ServiceBanquetStep2.vue?vue&type=script&lang=js"
import style0 from "./ServiceBanquetStep2.vue?vue&type=style&index=0&id=3ec693c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec693c4",
  null
  
)

export default component.exports